/**
 * The projects of one client, for the add and edit dialog's project field: the
 * monthly report's "work done" lists the time logged in the site's project
 * (docs/saidiseire-kiirus-turve-raport.md, item D).
 *
 * Read when the client is known, again when it changes, never polled. Open
 * projects only, by name, at most 100 (a client has a handful). `null` while
 * nothing is known (no client yet, still loading, or the read failed): the
 * dialog then keeps the site's current project as the one option besides
 * none, so saving the label never quietly drops it.
 */
import { useEffect, useState } from "react";
import { getProjects } from "../../../lib/projects";

export interface ClientProject {
  id: string;
  name: string;
}

export function useClientProjects(clientId: string | null): ClientProject[] | null {
  const [projects, setProjects] = useState<ClientProject[] | null>(null);
  useEffect(() => {
    setProjects(null);
    if (!clientId) return;
    let live = true;
    getProjects({ clientId, sort: "name", dir: "asc", pageSize: 100 })
      .then((page) => {
        if (live) setProjects(page.rows.map((p) => ({ id: p.id, name: p.name })));
      })
      .catch(() => {
        // Left null: the dialog falls back to the current project alone.
      });
    return () => {
      live = false;
    };
  }, [clientId]);
  return projects;
}
